<template>
  <div id="store-screen">
    <template v-if="!isLoading">
      <div class="page-action-wrapper" v-if="getActiveUser.role === 2">
        <rounded-button
          width="fit-content"
          height="35px"
          fontSize="15px"
          @click="createNewBox"
          >{{ $t("storeScreen.pageAction.newBox") }}
        </rounded-button>
      </div>
      <template v-if="boxes.length > 0 || filter">
        <transition name="fade">
          <boxes-filter
            @clickedFilter="clickedFilter"
            class="filter"
          ></boxes-filter>
        </transition>
        <transition name="fade">
          <template v-if="boxes.length === 0">
            <div class="empty-state" id="empty-state">
              <h5
                class="text"
                v-html="$t('storeScreen.boxList.filter.empty')"
              ></h5>
            </div>
          </template>
        </transition>
        <template v-if="boxes.length > 0">
          <template v-if="!contentLoading">
            <div class="type-count" id="type-count" v-if="boxesInfo">
              <div
                class="type-a"
                v-html="
                  $t('storeScreen.boxTypes.typeA', {
                    count: boxesInfo['0']
                  })
                "
              ></div>
              <div
                class="type-b"
                v-html="
                  $t('storeScreen.boxTypes.typeB', {
                    count: boxesInfo['1']
                  })
                "
              ></div>
              <div
                class="type-c"
                v-html="
                  $t('storeScreen.boxTypes.typeC', {
                    count: boxesInfo['2']
                  })
                "
              ></div>
            </div>
            <transition-group name="fade" class="box-items-wrapper" tag="div">
              <div
                class="box-items"
                v-for="(item, index) in boxes"
                :key="`box${index}`"
              >
                <box-item
                  @refreshData="refreshData"
                  :value="!(index === 0)"
                  :box="item"
                />
              </div>
            </transition-group>
          </template>
          <template v-else-if="contentLoading">
            <div class="loading-screen">
              <loader-ring />
            </div>
          </template>
          <pager
            v-if="showPager"
            @pageChanged="pageChanged"
            :page="currPage"
            class="pager"
            :itemPerPage="boxResponse.per_page"
            :itemsCount="boxResponse.total"
          ></pager>
        </template>
      </template>
      <template v-if="boxes.length === 0 && !filter">
        <div class="empty-state">
          <h5 class="text" v-html="$t('storeScreen.boxList.emptyState')"></h5>
        </div>
      </template>
    </template>
    <template v-if="isLoading">
      <div class="loading-screen">
        <loader-ring />
      </div>
    </template>
  </div>
</template>

<script>
import BoxesModal from "@/components/modules/Boxes/BoxesModal";
import BoxesFilter from "@/components/modules/Boxes/BoxesFilter";
import BoxItem from "@/components/modules/Boxes/BoxItem";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "BoxesScreen",
  props: {},
  components: {
    BoxItem,
    BoxesFilter
  },
  data: () => ({
    boxes: [],
    boxResponse: undefined,
    filter: undefined,
    boxesInfo: undefined,
    isLoading: false,
    currPage: 1,
    contentLoading: false
  }),
  created() {
    this.isLoading = true;
    this.getBoxes();
    this.getBoxesInfo();
  },
  computed: {
    ...mapGetters({
      getActiveUser: "user/getActiveUser"
    }),
    showPager() {
      if (this.boxResponse) {
        return this.boxResponse.total > this.boxResponse.per_page;
      }
      return false;
    }
  },
  methods: {
    ...mapActions({
      readBoxes: "boxes/readBoxes",
      readBoxInfo: "boxes/readBoxInfo"
    }),
    refreshData() {
      this.pageChanged(this.currPage);
      this.getBoxesInfo();
    },
    clickedFilter(filter) {
      this.filter = filter;
      this.pageChanged(1);
      this.getBoxesInfo();
      setTimeout(() => {
        if (document.getElementById("type-count")) {
          document.getElementById("type-count").scrollIntoView();
        } else if (document.getElementById("empty-state")) {
          document.getElementById("empty-state").scrollIntoView();
        }
      }, 200);
    },
    pageChanged(evt) {
      let pageCount = evt;
      this.currPage = pageCount;
      this.contentLoading = true;
      this.readBoxes({ page: this.currPage, filter: this.filter })
        .then(res => {
          if (res.status === "OK") {
            this.boxResponse = res.data;
            this.boxes = res.data.data;
            if (
              Math.ceil(this.boxResponse.total / this.boxResponse.per_page) <
              this.currPage
            ) {
              this.currPage = Math.ceil(
                this.boxResponse.total / this.boxResponse.per_page
              );
            }
          }
          this.contentLoading = false;
        })
        .catch(() => {
          this.contentLoading = false;
        });
    },
    getBoxesInfo() {
      this.readBoxInfo({ filter: this.filter }).then(res => {
        if (res.status === "OK") {
          this.boxesInfo = res.data;
        }
      });
    },
    getBoxes() {
      this.readBoxes({ page: 1, filter: this.filter })
        .then(res => {
          if (res.status === "OK") {
            this.boxResponse = res.data;
            this.boxes = res.data.data;
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    createNewBox() {
      this.$eventBus.showModal({
        title: this.$t("storeScreen.boxesModal.create.title"),
        bind: {
          is: BoxesModal,
          width: "fit-content",
          height: "fit-content"
        },
        on: {
          refreshData: () => {
            this.getBoxes();
            this.getBoxesInfo();
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#store-screen {
  min-height: 100%;
  padding-top: 15px;
  padding-bottom: 15px;
  display: flex;
  flex-direction: column;
  .type-count {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    div {
      padding-left: 10px;
      padding-right: 10px;
      border-right: 1px solid black;
    }
    div:first-of-type {
      padding-left: 0px;
    }
    div:last-of-type {
      padding-right: 0px;
      border-right: none;
    }
  }
  .box-items-wrapper {
    margin-top: 40px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px 10px;
    .box-items {
      width: 100%;
    }
  }
  .pager {
    margin-top: 25px;
  }
  .empty-state {
    margin-top: 50px;
  }
  .loading-screen {
    margin: auto;
  }
}
@media (max-width: 760px) {
  .box-items-wrapper {
    grid-template-columns: repeat(1, 1fr) !important;
  }
}
@media (max-width: 1200px) and (min-width: 761px) {
  .box-items-wrapper {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}
@media (max-width: 1600px) and (min-width: 1201px) {
  .box-items-wrapper {
    grid-template-columns: repeat(3, 1fr) !important;
  }
}
@media (max-width: 1900px) and (min-width: 1601px) {
  .box-items-wrapper {
    grid-template-columns: repeat(4, 1fr) !important;
  }
}
@media (min-width: 1900px) {
  .box-items-wrapper {
    grid-template-columns: repeat(5, 1fr) !important;
  }
}
</style>
